import {idFromPrefix} from '@@client/lib/forms'
import {classnames} from '@@client/lib/classes'
import FormField from '@@client/components/FormField'

const OneOption = ({
    kind = 'checkbox',
    name,
    id,
    errorId,
    label,
    value,
    isChecked,
    onChange,
    disabled,
}) => {
    return (
        <div className='field-checkbox-item'>
            <input type={kind} id={id} name={name} value={value} checked={isChecked} onChange={onChange} disabled={disabled ? 'disabled' : ''} aria-describedby={errorId} />
            <label htmlFor={id}>{label}</label>
        </div>
    )
}

export default function FormCheckboxList({
    idPrefix,
    name,
    onChange,
    className,
    selectedValues,
    options, // [{value, label}]
    disabled = false,
    kind = 'checkbox', // or 'radio'
    ...formFieldAtts
}) {
    const id = idFromPrefix(idPrefix, name)

    const errorId = idPrefix + '--error'

    const classNames = classnames([
        'field-checkbox-list',
        className,
    ])

    const isSelected = value => selectedValues.includes(value)

    const handleChange = e => {
        const value = (e && e.target) ? e.target.value : e
        const previouslySelected = isSelected(value)

        return previouslySelected
            ? onChange(selectedValues.filter(x => x !== value))
            : onChange([...selectedValues, value])
    }

    return (
        <FormField errorId={errorId} className={classNames} {...formFieldAtts}>
            {options.map((info, i) => (
                <OneOption
                    id={id + '--' + i}
                    kind={kind}
                    isChecked={isSelected(info.value)}
                    name={name}
                    key={info.value}
                    label={info.label}
                    value={info.value}
                    disabled={disabled}
                    errorId={errorId}
                    onChange={handleChange}
                />
            ))}
        </FormField>
    )
}
